module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Notice widget

(function (fox){

	var _ = {
		wrappCallbackMethods: function () {
			var opt;

			fox.each(this._callbackMethods, function (val) {
				opt = this.getOption(val);

				if (opt) {
					if (fox.isString(opt)) {
						this['_function_' + val] = 
							fox.oop.getRealCallback(fox.oop.createCallback(opt, this));
					} else if (fox.isFunction(opt)) {
						this['_function_' + val] = opt;
					}
				}

			}, this);
		},

		getCallbackFunction: function () {
			var name;

			name = Array.prototype.splice.call(arguments, 0, 1);

			if (this['_function_' + name]) {
				return this['_function_' + name].apply(this, arguments);
			}
		},
	}

	fox.registerWidget('Notice', {

		configure: function (options){
			this._callbackMethods = ['beforeRemove', 'onCreate'];

			this.registerOptions('', {
				'tpl.row': 'notice',
				container: '.notice-container',
				autoRender: true,
				autoClose: 2000,
				delayRemove: false,
				beforeRemove: false, //method
				onCreate: false // method
			});
			
			this.callParent('configure', arguments);
		},

		init: function () {
			_.wrappCallbackMethods.call(this);
		
			this.callParent('init', arguments);
		},

		add: function (item, render) {
			render = render || true;
			
			if (this.getCollectionItem(item.alias)) {
				return;
			}

			this.collection.push({
				alias: item.alias,
				type: item.type,
				message: item.message
			});

			if (render) {
				this.renderItem(item);
			}
			
			return this;
		},

		clear: function (render) {
			fox.each(this.collection, function (item) {
				this.deleteItem(item.alias);
			},this);

			return this;
		},

		getCollectionItem: function (alias) {
			var result = false;
			fox.each(this.collection, function (item) {
				if (item.alias == alias) {
					result = item;
				}
			});
			return result;
		},

		renderItem: function (data) {
			if (!this.element[0]) {
				return;
			}

			var item;

			if (fox._isNewfe) {
				item = this.row.setData([data]).compile();
			} else {
				item = fox.Zen(this.row, [data]);
			}

			this.getOption('onCreate') ? 
				_.getCallbackFunction.call(this, 'onCreate', item) : 
				this.element[0].appendChild(item);
			
			this.dispatchEvent('added', data);

			//one item autoClose
			if (fox.isNumeric(data.autoClose)) {
				if (!data.autoClose) {
					return this;
				}
				
				window.setTimeout(fox.bind(function () {
					this.deleteItem(data.alias);
				}, this), data.autoClose);

				return this;
			}

			//global autoClose for all items
			if (this.getOption('autoClose')) {
				window.setTimeout(fox.bind(function () {
					_.getCallbackFunction.call(this, 'beforeRemove', data);

					this.deleteItem(data.alias);
				}, this), this.getOption('autoClose'));
			}

			return this;
		},

		deleteItem: function (alias) {
			var arr = [];
			fox.each(this.collection, function (item) {

				if (item.alias == alias) {
					var elmnt = fox.dom.selectFirst('[notice-alias="' + item.alias + '"]', this.element[0]);
					if (elmnt) {
						if (this.getOption('delayRemove')) {
							setTimeout(function () {
								elmnt.remove()
							}, this.getOption('delayRemove'));
						} else {
							elmnt.remove();	
						}
					}					
					this.dispatchEvent('deleted', item);
				} else {
					arr.push(item);
				};

			}, this);

			this.collection = arr;
		},

		getRenderedItem: function (alias) {
			return this.dom1('[notice-alias="' + alias + '"]');
		}

	}, 'List');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/notice.js
// module id = 334
// module chunks = 2